import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ActionReferenceData, ActionReferenceValue } from '../actions.model';
import {
  SystemCodeCatalog,
  SystemCodeCatalogService,
} from '../../system-codes/system-code-catalog.service';
import type { ActionReferenceApi } from './action-reference-api.token';

const ACTION_TYPE_CODE_TYPE = 'action_type';
const ACTION_STATUS_CODE_TYPE = 'action_status';
const ACTION_PRIORITY_CODE_TYPE = 'action_priority';
const COMMUNICATION_PREFERENCES_CODE_TYPE = 'communication_preferences';

@Injectable()
export class HttpActionReferenceService implements ActionReferenceApi {
  private readonly _systemCodes = inject(SystemCodeCatalogService);

  loadReferenceData(): Observable<ActionReferenceData> {
    return this._systemCodes.load().pipe(
      map((catalog) => ({
        actionTypes: this._values(catalog, ACTION_TYPE_CODE_TYPE),
        statuses: this._values(catalog, ACTION_STATUS_CODE_TYPE),
        priorities: this._values(catalog, ACTION_PRIORITY_CODE_TYPE),
        communicationPreferences: this._values(
          catalog,
          COMMUNICATION_PREFERENCES_CODE_TYPE,
        ),
        dependencyMessage: null,
      })),
    );
  }

  private _values(
    catalog: SystemCodeCatalog,
    codeType: string,
  ): ActionReferenceValue[] {
    return this._systemCodes
      .values(catalog, codeType)
      .map(({ code, label }) => ({ code, label }))
      .sort((left, right) => left.label.localeCompare(right.label));
  }
}
